import { NgModule} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from '../app.routes';
import { ClientListComponent } from './list/client-list.component';
import { ClientNewComponent } from './new/client-new.component';
import { ClientDetailComponent } from './detail/client-detail.component';
import { ClientService } from './client.service';
import { CommonModule } from '../common/common.module';

@NgModule({
    imports: [BrowserModule, FormsModule, ReactiveFormsModule,  AppRoutingModule, CommonModule],
    declarations: [ClientListComponent, ClientNewComponent, ClientDetailComponent],
    providers: [ClientService]
})
export class ClientModule {}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/client/client.module.ts